import { Fragment, type JSX } from 'react';
// import "react-confirm-alert/src/react-confirm-alert.css";
import '@fontsource/noto-sans-jp/400.css';
import '@fontsource/noto-sans-jp/500.css';
import '@fontsource/noto-sans-jp/700.css';
import NotificationMessage from 'components/NotificationMessage';
import ModalConfirm from 'components/modal/ModalConfirm';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import './assets/styles/app.scss';
import AppErrorBoundary from './components/error/AppErrorBoundary';
import './config/amplifyConfig';
import AppRoutes from './routes/AppRoutes';

export default function App(): JSX.Element {
  return (
    <Fragment>
      <BrowserRouter>
        <AppErrorBoundary>
          <>
            {/* ルート定義 */}
            <AppRoutes />
            {/* 共通確認モーダル */}
            <ModalConfirm />
            {/* 共通メッセージ通知 */}
            <NotificationMessage />
          </>
        </AppErrorBoundary>
      </BrowserRouter>
    </Fragment>
  );
}
